import React from 'react';
import { withRouter } from '../../util/withRouter';
import { connect } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import {
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER,
} from '../../constants/ActionTypes';
import { switchLanguage, toggleCollapsedNav } from '../../actions/Setting';
import Menu from '../../components/TopNav/Menu';
import UserInfo from '../../components/UserInfo';
import { IntlMessages } from '../../components/';

import NotificationsIcon from '@mui/icons-material/Notifications';
import ForumIcon from '@mui/icons-material/Forum';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import { subscribeToGlobalUnreadCount } from '../../services/supportChatService';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: undefined,
      searchBox: false,
      searchText: '',
      mailNotification: false,
      userInfo: false,
      langSwitcher: false,
      appNotification: false,
      totalCount: 0,
      notifications: [],
      unreadCount: props.unreadCount,
      supportUnreadCount: 0,
      isSupportChat: localStorage.getItem('isSupportChat') !== 'false',
    };
  }

  componentDidMount() {
    if (this.state.isSupportChat) {
      try {
        this.unsubscribeSupportUnread = subscribeToGlobalUnreadCount((count) => {
          this.setState({ supportUnreadCount: count });
        });
      } catch (e) {}
    }

    this.handleProfileUpdated = (event) => {
      const allowed =
        event?.detail?.isSupportChat !== undefined
          ? event.detail.isSupportChat !== false
          : localStorage.getItem('isSupportChat') !== 'false';

      this.setState({ isSupportChat: allowed });

      if (allowed && !this.unsubscribeSupportUnread) {
        try {
          this.unsubscribeSupportUnread = subscribeToGlobalUnreadCount((count) => {
            this.setState({ supportUnreadCount: count });
          });
        } catch (e) {}
      } else if (!allowed && this.unsubscribeSupportUnread) {
        this.unsubscribeSupportUnread();
        this.unsubscribeSupportUnread = null;
        this.setState({ supportUnreadCount: 0 });
      }
    };
    window.addEventListener('admin_profile_updated', this.handleProfileUpdated);
  }

  componentWillUnmount() {
    if (this.unsubscribeSupportUnread) {
      this.unsubscribeSupportUnread();
    }
    if (this.handleProfileUpdated) {
      window.removeEventListener('admin_profile_updated', this.handleProfileUpdated);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.unreadCount !== this.props.unreadCount) {
      this.setState({ unreadCount: this.props.unreadCount });
    }
  }

  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification,
    });
  };
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification,
    });
  };
  onLangSwitcherSelect = (event) => {
    this.setState({
      langSwitcher: !this.state.langSwitcher,
      anchorEl: event.currentTarget,
    });
  };
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox,
    });
  };
  onAppsSelect = () => {
    this.setState({
      apps: !this.state.apps,
    });
  };
  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo,
    });
  };
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      userInfo: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
      apps: false,
    });
  };
  onToggleCollapsedNav = () => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };

  updateSearchText(evt) {
    this.setState({
      searchText: evt.target.value,
    });
  }

  render() {
    const { drawerType, navigationStyle, horizontalNavPosition } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? 'd-block d-xl-none'
      : drawerType.includes(COLLAPSED_DRAWER)
        ? 'd-block'
        : 'd-none';

    return (
      <AppBar
        className={`app-main-header custom-color ${
          navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER
            ? 'app-main-header-top'
            : ''
        }`}
      >
        <Toolbar className="app-toolbar" disableGutters={false}>
          {navigationStyle === HORIZONTAL_NAVIGATION ? (
            <div className="d-block d-md-none pointer mr-3" onClick={this.onToggleCollapsedNav}>
              <span className="jr-menu-icon">
                <span className="menu-icon" />
              </span>
            </div>
          ) : (
            <>
              <IconButton
                className={`jr-menu-icon mr-3 ${drawerStyle}`}
                aria-label="Menu"
                onClick={this.onToggleCollapsedNav}
              >
                <span className="menu-icon" />
              </IconButton>
              <div class="header-title">
                <img src={'assets/images/logo.png'} alt="Jambo" class="mobile-logo" title="Jambo" />
                <h3>
                  <IntlMessages id="common.panel" />
                </h3>
              </div>
            </>
          )}

          {navigationStyle === HORIZONTAL_NAVIGATION &&
            horizontalNavPosition === INSIDE_THE_HEADER && <Menu />}

          <ul className="header-notifications list-inline ml-auto d-flex align-items-center">
            {this.state.isSupportChat && (
              <li className="list-inline-item">
                <Tooltip title="Support Chat">
                  <IconButton
                    color="inherit"
                    onClick={() => this.props.navigate('/app/support-chat')}
                  >
                    <Badge badgeContent={this.state.supportUnreadCount} color="secondary" max={99}>
                      <ForumIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>
              </li>
            )}
            <li className="list-inline-item">
              <IconButton
                color="inherit"
                onClick={() => this.props.navigate('/app/all-notifications')}
              >
                <Badge badgeContent={this.state.unreadCount} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            </li>
            <li className="list-inline-item app-tour">
              <UserInfo />
            </li>
          </ul>

          <div className="ellipse-shape"></div>
        </Toolbar>
      </AppBar>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { drawerType, locale, navigationStyle, horizontalNavPosition } = settings;
  return { drawerType, locale, navigationStyle, horizontalNavPosition };
};

export default withRouter(connect(mapStateToProps, { toggleCollapsedNav, switchLanguage })(Header));
